// Replaces Next.js's built-in polyfill module. Everything it polyfills is native in the
// browsers listed in package.json "browserslist" except URL.canParse (Safari < 17).
if (!('canParse' in URL)) {
  URL.canParse = function (url, base) {
    try {
      return !!new URL(url, base)
    } catch {
      return false
    }
  }
}
